import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { router } from '@inertiajs/react'
import { Button } from 'client/components/Button/Button'
import ProductImage from 'images/product.jpg'
import { useShoppingCartController } from 'client/controllers/cartController'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { CURRENCY_SIGN } from 'lib/constants/currency'
type TProps = {
  data: Data.Product
}

const ProductCard: FC<TProps> = ({ data }) => {
  const { addProduct } = useShoppingCartController()
  const { t } = useTranslation(ClientLocaleNS.HomePage)
  return (
    <div
      className="flex w-full cursor-pointer flex-col items-center h-full"
      onClick={() => router.get(`/products/${data.id}`)}
    >
      <div className="relative flex w-full overflow-hidden rounded-t-xl shadow-sm">
        <img
          src={data.image ?? ProductImage}
          className="w-full object-cover"
          style={{
            aspectRatio: '11/12',
          }}
        />
        <div className="absolute left-4 top-4">
          <Button className="font-body---14px h-7 px-4">{t('products_block.new')}</Button>
        </div>
      </div>
      <div className="flex w-full flex-col gap-4 overflow-hidden rounded-b-xl bg-palette-white p-3 flex-1">
        <div className="flex w-full flex-col gap-2 flex-1">
          <Text tagName="span" className="font-body---24px flex-1 flex" title={data.name}>
            {data.name}
          </Text>
          {!!data.seller?.id && (
            <Text tagName="span" className="font-body---14px text-palette-grey--50">
              {data.seller.name}
            </Text>
          )}
        </div>
        <Text tagName="span" className="font-body---24px">{`${CURRENCY_SIGN}${data.price}`}</Text>
        <Button
          onClick={(e) => {
            e.stopPropagation()
            addProduct(data)
          }}
        >
          {t('products_block.add')}
        </Button>
      </div>
    </div>
  )
}

export { ProductCard }
